<!--
Author: TangChen
Date: 2018-11-26
Desc: 用户持有银行卡信息操作组件，由index.js 配置引入
-->
<template>
    <div class="comp-bank-operation comp">
        <!-- 验证证件信息 -->
        <el-form
            v-if="!checked"
            ref="acctInfo"
            :model="acctInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="姓名：" class="form-text">
                <div class="text-con">
                    {{ info.custname }}
                </div>
            </el-form-item>
            <el-form-item :label="$cache.getDict('130007',info.certificatetype)+'：'" class="form-text">
                <div class="text-con">
                    {{ info.certificateno }}
                </div>
            </el-form-item>
            <el-form-item v-if="cate==='add'" label="所属银行：" prop="bankType" class="bank">
                <div class="bank-msg" :style="{'opacity':bankInfo.channelid?1:0}" v-on:click="bankVisible=!bankVisible">
                    <div v-if="bankInfo.channelid" class="bank-img-sel clear" :class="{'bg-w':bankInfo.channelid}">
                        <img
                            :src="$util.getImg(bankInfo.bankid)"
                            title="bank-img"
                        >
                        <span class="k-text-flow">{{ bankInfo.channelname.toString().substr(0,10) + (bankInfo.channelname.toString().length > 10 ? "..." : "") }}</span>
                        <i v-if="!isRemit" class="paycenter">{{ $cache.getDict("110079",bankInfo.paycenterid).toString().substr(0,4)
                        }}</i>
                    </div>
                </div>
                <el-input
                    v-model.trim="acctInfo.bankType"
                    placeholder="请选择所属银行"
                    :maxlength="20"
                    suffix-icon="fa fa-money-check"
                    :readonly="true"
                />
            </el-form-item>
            <el-form-item v-else label="所属银行：" class="bank form-text">
                <div class="bank-msg">
                    <div v-if="bankInfo.channelid" class="bank-img-sel clear" :class="{'bg-w':bankInfo.channelid}">
                        <img
                            :src="$util.getImg(bankInfo.bankid)"
                            title="bank-img"
                        >
                        <span class="k-text-flow">{{ $cache.getDict("110080",bankInfo.channelid).toString().substr(0,10) + ($cache.getDict("110080",bankInfo.channelid).toString().length > 10 ? "..." : "") }}</span>
                        <i class="paycenter">{{ $cache.getDict("110079",bankInfo.paycenterid).toString().substr(0,4)
                        }}</i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item v-if="bankInfo.hkopenflag==='1'&& cate ==='add'" label="开通汇款支付：" prop="hkopenflag" class="form-text">
                <el-radio-group v-model="acctInfo.hkopenflag">
                    <el-radio :label="'1'">
                        是
                    </el-radio>
                    <el-radio v-if="!isRemit" :label="'0'">
                        否
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="cate!=='add'" label="银行卡号码：" class="form-text">
                <div class="text-con">
                    {{ acctInfo.oldBank }}
                </div>
            </el-form-item>
            <el-form-item
                v-if="cate==='change'|| cate ==='add'"
                :label="(cate==='change'?'新':'')+'银行卡号码：'"
                prop="bankcard"
            >
                <div v-show="showBankCard&&acctInfo.bankcard!==''" class="bank-code el-message--warning" :class="{'show':showBankCard&&acctInfo.bankcard!==''}">
                    {{ $util.getNewCard(acctInfo.bankcard) }}
                </div>
                <el-input
                    v-model.trim="acctInfo.bankcard"
                    placeholder="请输入银行卡号码"
                    :maxlength="20"
                    v-on:focus="showBankCard=true"
                    v-on:blur="showBankCard=false"
                />
            </el-form-item>
            <el-form-item
                v-if="bankInfo.isneedbank==='1'||(cate==='modify'&&acctInfo.province)"
                label="开户行所在省："
                prop="province"
            >
                <el-select v-model="acctInfo.province" filterable placeholder="请选择开户行所在省">
                    <el-option
                        v-for="item in province"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitemname"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="(bankInfo.isneedbank==='1'||cate==='modify')&&acctInfo.province!==''"
                label="开户行所在城市："
                prop="city"
            >
                <el-select v-model="acctInfo.city" filterable placeholder="请选择开户行所在城市">
                    <el-option
                        v-for="item in city"
                        :key="item.cityid"
                        :label="item.cityname"
                        :value="item.cityname"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="(bankInfo.isneedbank==='1' || cate==='modify') && acctInfo.city!==''"
                label="开户行名称："
                prop="bankname"
            >
                <el-autocomplete
                    v-model.trim="acctInfo.bankname"
                    class="inline-input"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入开户行名称"
                    :maxlength="40"
                >
                    <el-tooltip
                        slot="suffix"
                        class="item"
                        effect="info"
                        :content="infoText"
                        placement="top"
                    >
                        <el-button class="info-btn">
                            <i class="el-icon-question" />
                        </el-button>
                    </el-tooltip>
                </el-autocomplete>
            </el-form-item>
            <el-form-item v-if="cate!=='add' && !emptyMobile" label="银行预留手机号码：" class="form-text">
                <div class="text-con">
                    <span>{{ acctInfo.mobile }}</span>
                    <div class="other-prompt">
                        <i class="el-icon-warning" /><span>不是该银行卡的预留手机号码？</span><span
                            class="like-a"
                            v-on:click="changeMobile=!changeMobile"
                        >{{ changeMobile?"放弃":"" }}修改手机号码</span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item
                v-if="changeMobile || emptyMobile && cate!=='modify'"
                :label="(changeMobile?'新':'银行预留')+'手机号码：'"
                prop="newMobile"
            >
                <el-input v-model.trim="acctInfo.newMobile" placeholder="请输入银行预留手机号码" :maxlength="11" />
            </el-form-item>
            <el-form-item v-if="cate =='add' && isRemit" label="银行卡正反面：" class="form-text">
                <bankcard-upload v-on:change="imgUp" />
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="tradepwd">
                <el-input
                    v-model.trim="acctInfo.tradepwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <!--<el-form-item
                v-if="cate!=='modify' && bankInfo && bankInfo.identifytype === '1'"
                label="验证码："
                prop="verifyCode"
                :class="{'form-text':!isPwdCheck}"
            >
                <el-input v-model.trim="acctInfo.verifyCode" placeholder="请输入手机验证码" :maxlength="6">
                    <el-button slot="append" class="get-verify" :disabled="time>0" v-on:click="mobileCheck">
                        {{ btnMsg }}
                    </el-button>
                </el-input>
            </el-form-item>-->
            <el-form-item style="margin-left:-80px">
                <div class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: flex-start;">
                        <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                        <span v-if="isRemit" style="padding-left:5px;line-height:30px;width:518px;">
                            本人承诺提供的身份信息、银行卡信息真实、合法、有效，并同意泰康人寿收集、使用本人“银行卡号、手机号、姓名、身份证号”于绑定银行卡和基金交易的用途。
                        </span>
                        <span v-else style="padding-left:5px;line-height:30px;width:518px;">
                            本人已经仔细阅读并同意
                            <span style="cursor: pointer;color:red;" v-on:click="isShowAgreement=true">《委托支付协议》</span>
                            等法律文件，同意本人发卡行提供的快捷支付服务协议内容，
                            并同意泰康人寿使用本人“银行卡号、手机号、姓名、身份证号”于绑定银行卡和基金交易的用途。
                        </span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button type="primary" class="medium" v-on:click="mobileCheck">
                        下一步
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <bank-lists :bank-visible="bankVisible" url="acct/addbank/banklist" v-on:bank-hide="getBankMsg" />
        <result
            v-if="checked"
            :result="result"
            v-on:login-now="$router.push({name:'fund'})"
            v-on:return-login="$router.push({name:'bank'})"
        />
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <agreement v-model="protocol" :data="cate" v-on:all-read="agreePro"></agreement>
        <mobile-code :mobile-visible="mobileVisible" v-on:verify-in="getMobileCode" />
        <agreement2 v-model="isShowAgreement" agrCon="agreement_payment" title="委托支付协议" v-on:all-read="isShowAgreement=false"></agreement2>
    </div>
</template>
<script>
import bankLists from "@/components/form/bankLists.vue";
import result from "@/components/layout/result.vue";
import Agreement from "@/components/form/agreement.vue";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCode.vue";
import agreement2 from "@/components/form/agreement2.vue";
import bankcardUpload from "@/components/form/bankcardUpload.vue";

export default {
    name: "BankOperation",
    components: {
        bankLists,
        result,
        Agreement,
        mobileCode,
        imgCode,
        agreement2,
        bankcardUpload
    },
    props: {
        cate: {
            type: String,
            default: "add"
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            mobileVisible: false,
            showBankCard: false, // 是否着重显示银行卡号码
            province: [], // 省
            city: [], // 城市
            acctInfo: { // 表单参数配置
                bankType: "",
                bankcard: "",
                mobile: "",
                newMobile: "",
                province: "",
                city: "",
                hkopenflag: "",
                bankname: "",
                verifyCode: "",
                tradepwd: ""
            },
            emptyMobile: true,
            cateText: "",
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的银行卡已添加成功！",
                btnMsg: "您新增的银行卡为：民生银行（通联）尾号[1234]",
                btnL: {
                    text: "去购买基金",
                    event: "login-now"
                },
                btnR: {
                    text: "查看我的银行卡",
                    event: "return-login"
                }
            },
            bankCate: "",
            infoText: "如果下拉选项中及搜索结果中没有您的开户行，请输入开户行名称或选择附近的开户行",
            query: null, // 定时查找
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            oldBankInfo: {}, // 保存旧银行卡信息
            isPwdCheck: false, // 是否校验密码
            checked: false,
            changeMobile: false,
            bankVisible: false, // 是否弹出银行卡列表
            info: {},
            locked: false, // 是否已发送短信
            isCheckVerifyCode: true,
            branchList: [],
            protocol: false,
            rules: { // 校验规则
                bankType: [
                    {required: true, message: "请选择所属银行", trigger: "blur"}
                ],
                bankcard: [
                    {required: true, message: "请输入银行卡号码", trigger: "blur"},
                    {validator: this.$util.validateBankNum, trigger: "blur"}
                ],
                mobile: [
                    {required: true, message: "请输入银行预留手机号码", trigger: "blur"},
                    {validator: this.$util.validateMobile, trigger: "blur"}
                ],
                newMobile: [
                    {required: true, message: "请输入银行预留手机号码", trigger: "blur"},
                    {validator: this.$util.validateMobile, trigger: "blur"}
                ],
                province: [
                    {required: true, message: "请输入开户省", trigger: "change"}
                ],
                city: [
                    {required: true, message: "请输入开户市", trigger: "change"}
                ],
                bankname: [
                    {required: true, message: "请输入开户行名称", trigger: "change"},
                    {validator: this.$util.validateBankName, trigger: "change"}
                ],
                tradepwd: [
                    {required: true, message: "请输入交易密码", trigger: "blur"}
                ],
                verifyCode: [
                    {validator: this.validateVerifyCode, trigger: "blur"}
                ]
            },
            bankInfo: {},
            checkbox: false,// 是否同意隐私政策
            isShowAgreement: false,// 是否展示文件内容弹窗
            isRemit: false, // 是否汇款卡，需要上传银行卡照片
            imgBase64: {} //银行卡照片Base64
        };
    },
    watch: {
        "acctInfo.province"(val) {
            const _this = this;
            // 城市查询
            const _p = _this.province.find(item => {
                return item.subitemname === val;
            });
            this.$util.getCity(_p.subitem, data => {
                _this.city = data || [];
                let _cityObj = {};
                let _city = "";
                // 城市查询结果是否存在
                if (_this.city.length > 0) {
                    // 是否存在旧的城市选项
                    if (_this.oldBankInfo.city && _this.oldBankInfo.province === val) {
                        _cityObj = _this.city.find(item => {
                            return item.cityname === _this.oldBankInfo.city || item.cityid === _this.oldBankInfo.city;
                        });
                        _this.oldBankInfo.city = _cityObj.cityname || "";
                    }
                    _city = _cityObj.cityname || _this.city[0].cityname;
                }
                _this.$set(_this.acctInfo, "city", _city || "");
            });
        },
        "acctInfo.city"(val) {
            if (!val) return;
            if (this.oldBankInfo.city === this.acctInfo.city && this.oldBankInfo.name) {
                this.$util.querySearch(this, this.oldBankInfo.name, this.bankInfo.bankid);
                this.$set(this.acctInfo, "bankname", this.oldBankInfo.city === this.acctInfo.city ? this.oldBankInfo.name : "");
            }
        },
        changeMobile(val) {
            if (!val) {
                this.acctInfo.newMobile = "";
            }
        }
    },
    // 初始化组件数据
    created() {
        this.info = this.$cache.getUser();
        this.getBankCate();
        this.isPwdCheck = this.$cache.getPwdCheck(this.bankCate);
        this.province = this.$cache.getDict("190021");
        const _x = this.$route.query;
        // 初始化银行卡信息数据
        if (_x && _x.channelid) {
            this.isRemit = _x.paycenterid == "2000";
            const _p = this.province.find(item => {
                return item.subitemname === _x.bankprovince || item.subitem === _x.bankprovince;
            }) || {};
            this.oldBankInfo = {
                province: _p.subitemname || "",
                city: _x.bankcity,
                name: _x.branchname
            };
            const _z = {oldBank: _x.bankcard};
            this.acctInfo = Object.assign(this.acctInfo, _z, _x);
            if (this.cate === "change" || this.isRemit) {
                this.acctInfo.bankcard = "";
            }
            this.emptyMobile = !_x.mobile.trim();
            this.$set(this.acctInfo, "bankType", _x.channelid);
            this.$set(this.acctInfo, "province", _p.subitemname || "");
            if (this.isRemit) {
                _x.hkopenflag = "1";
                _x.channelname = _x.channelname || "";
                this.bankInfo = _x;
                this.acctInfo.hkopenflag = "1";
                return;
            }
            this.bankInfo = {
                bankid: _x.bankid,
                channelid: _x.channelid,
                paycenterid: _x.paycenterid,
                identifytype: _x.identifytype
            };
        }
    },
    methods: {
        getVerifyCode(val){
            this.dialogVisible = false;
            if(val){
                this.getParams(val);
            }
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.checkbox = false;
                this.bankInfo = val.bank;
                this.acctInfo.bankType = this.bankInfo.channelid;
                this.acctInfo.hkopenflag = this.bankInfo.hkopenflag;
                this.isRemit = this.bankInfo.paycenterid == "2000";
            }
            if (this.isRemit) {
                this.acctInfo.hkopenflag = "1";
            }
        },
        agreePro(val){
            this.protocol = false;
            if(!val)return;
            if (this.bankInfo.identifytype === "1" && this.cate !== "modify" && !this.isRemit) {
                this.mobileVisible = true;
            } else {
                this.getParams();
            }
        },
        validateVerifyCode(rule, value, callback) {
            if (this.isCheckVerifyCode) {
                this.$util.validateVerifyCode(rule, value, callback);
            } else {
                callback();
            }
        },
        // 手机发送短信
        mobileCheck() {
            if(!this.checkbox){
                const text = this.isRemit ? "根据相关法规要求，请仔细阅读本页提示内容，并勾选“承诺并同意”选项。" : "根据相关法规要求，请仔细阅读相关文件，并勾选“我已阅读并同意”选项。";
                return this.$alert(text, "提示", {confirmButtonText: "确定"});
            }
            if (this.cate === "add" && this.isRemit) {
                if (!this.imgBase64.frontBank && !this.imgBase64.backBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡正反面文件"
                    });
                    return;
                }
                if (!this.imgBase64.frontBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡正面文件"
                    });
                    return;
                }
                if (!this.imgBase64.backBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡反面文件"
                    });
                    return;
                }
            }
            this.isCheckVerifyCode = false;
            this.$refs["acctInfo"].validate(valid => {
                this.isCheckVerifyCode = true;
                if (valid) {
                    if(this.bankInfo.identifytype === "1" && this.cate !== "modify" && !this.isRemit){
                        this.dialogVisible = true;
                    }else{
                        this.getParams("");
                    }
                } else {
                    return false;
                }
            });
        },
        getMobileCode(val){
            this.mobileVisible = false;
            if(val){
                this.checkVerifyCode(val);
            }
            return false;
        },
        getParams(verifyCode) {
            let params = {
                channelid: this.acctInfo.bankType
            };
            /* params.mobile = this.acctInfo.newMobile || this.acctInfo.mobile; */
            params.mobile = this.acctInfo.newMobile;
            if (this.acctInfo.tradepwd) {
                params.tradepwd = this.$util.enc(this.acctInfo.tradepwd);
            }
            if (this.cate === "sign" || this.cate === "unsign" || this.cate === "active") {
                this.cateText = this.cate === "sign" ? "签约" : (this.cate === "unsign" ? "解约" : "激活");
                const _x = {
                    moneyaccount: this.acctInfo.moneyaccount,
                    paycenterid: this.acctInfo.paycenterid,
                    verifycode: verifyCode || ""
                };
                params = Object.assign({}, params, _x);
            } else {
                let branchcode = "";
                // 获取联行号
                const _y = this.branchList.filter(branch => {
                    return branch.branchname === this.acctInfo.bankname;
                });
                if (_y && _y[0]) {
                    branchcode = _y[0].exchangecode;
                }
                const _bankInfo = {
                    exchangecode: branchcode,
                    branchnum: branchcode,
                    bankprovince: this.acctInfo.province,
                    bankcity: this.acctInfo.city,
                    branchname: this.acctInfo.bankname,
                    verifycode: verifyCode || ""
                };
                params = Object.assign({}, params, _bankInfo);
                // 添加额外参数
                if (this.cate === "add") {
                    this.cateText = "新增";
                    const _x = {
                        channelname: this.bankInfo.channelname,
                        hkopenflag: this.acctInfo.hkopenflag,
                        bankcard: this.acctInfo.bankcard
                    };
                    params = Object.assign({}, params, _x);
                    if (this.isRemit) {
                        this.addRemitBankcard(params);
                        return;
                    }
                } else if (this.cate === "modify") {
                    this.cateText = "修改";
                    const _x = {
                        moneyaccount: this.acctInfo.moneyaccount
                    };
                    params = Object.assign({}, params, _x);
                    this.sendBank("acct/bank/card", params);
                    return false;
                }
                if (this.cate === "change") {
                    this.cateText = "更换";
                    const _x = {
                        bankcard: this.acctInfo.bankcard,
                        moneyaccount: this.acctInfo.moneyaccount
                    };
                    params = Object.assign({}, params, _x);
                }
            }
            this.sendBank("acct/" + this.cate + "card/authsend", params);
        },
        // 新增汇款卡
        addRemitBankcard(params) {
            const data = {
                hkopenflag: "1",
                hkpaycenterflag: "1",
                bankid: this.bankInfo.bankid,
                channelid: this.acctInfo.bankType,
                depositacct: this.acctInfo.bankcard,
                depositprov: this.acctInfo.province,
                depositcity: this.acctInfo.city,
                bankname: this.acctInfo.bankname,
                paycenterid: this.bankInfo.paycenterid,
                channelname: this.bankInfo.channelname,
                moneyaccount: "1",
                exchangebankcode: params.exchangecode,
                cardtelno: this.acctInfo.newMobile
            };
            const _this = this;
            _this.$util.request("acct/bank/addhkcard", data, "POST").then(res => {
                if (res.data) {
                    _this.result.msg = "银行卡信息上传成功，请耐心等待审核结果";
                    _this.result.btnMsg = "";
                    _this.result.btnL = {
                        text: "确认",
                        event: "return-login"
                    };
                    _this.result.btnR = {};
                    _this.checked = true;
                    _this.uploadBankCard();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        sendBank(url, data) {
            const _this = this;
            const _way = this.cate === "modify" ? "PUT" : "POST";
            if (_way === "PUT" && this.acctInfo.newMobile === ""
                && (this.$route.query.bankcity.trim() !== "" ? (this.acctInfo.city === this.$route.query.bankcity.trim()) : true)
                && (this.$route.query.branchname.trim() !== "" ? (this.acctInfo.bankname === this.$route.query.branchname.trim()) : true)
            ) {
                this.$message({
                    type: "warning",
                    message: "未做任何修改，请先做修改再进行提交"
                });
                return false;
            }
            this.$util.request(url, data, _way).then(res => {
                if (res.data) {
                    if (_this.bankInfo.identifytype === "2" || _this.cate === "modify" || _this.cate === "unsign") {
                        _this.getSuccessInfo();
                    } else if (_this.bankInfo.identifytype === "1") {
                        let result = res.data[0];
                        if(result && result.comtype && result.comtype === "socket"){
                            this.getSuccessInfo();
                        }else {
                            _this.time = res.data[0].sendperiod;
                            _this.locked = true;
                            _this.$util.btnDisabled(this);
                            _this.submitInfo("acctInfo");
                        }
                    } else if (_this.bankInfo.identifytype === "3") {
                        const pageUrl = res.data[0] ? res.data[0].url : "";
                        _this.$util.newWinOpen(pageUrl);
                        _this.$util.confirmBankAuth(_this, {}, "acct/" + _this.cate + "card/bizresult", () => {
                            _this.getSuccessInfo();
                        });
                    }
                }
            });
        },
        // 处理银行卡操作成功信息
        getSuccessInfo() {
            // 用户首次增卡更新
            if (this.fn) {
                const info = this.$cache.getUser();
                info.activecardnum = Number(info.activecardnum) + 1;
                this.$store.dispatch("setInfo", info).then(() => {
                    this.$emit("fn-back", true);
                });
            } else { // 绑定交易账户后更新
                this.$cache.refreshUser();
                this.result.msg = "您的银行卡已" + this.cateText + "成功！";
                const _num = this.cate === "add" ? this.acctInfo.bankcard : this.acctInfo.oldBank;
                this.result.btnMsg = "您" + this.cateText + "的银行卡为：" + this.$cache.getDict("110080", this.bankInfo.channelid) + "（" + this.$cache.getDict("110079", this.bankInfo.paycenterid) + "）尾号[" + _num.substr(_num.length - 4, 4) + "]";
                this.checked = true;
            }
        },
        // 生成搜索列表
        querySearch(queryString, cb) {
            this.$util.querySearch(this, queryString, this.bankInfo.bankid, cb);
        },
        submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.bankInfo.identifytype === "1" && this.cate !== "modify" && !this.isRemit) {
                        if (!this.locked) {
                            this.$message({
                                type: "warning",
                                message: "请先发送手机短信验证码"
                            });
                            return false;
                        }
                    }
                    this.protocol = true;
                } else {
                    return false;
                }
            });
        },
        /* 校验手机验证码 */
        checkVerifyCode(val) {
            const _this = this;
            this.$util.request("acct/" + this.cate + "card/authcheckmsg", {verifycode: val}, "POST").then(res => {
                if (res.data) {
                    _this.getSuccessInfo();
                }
            });
        },
        getBankCate() {
            switch (this.cate) {
            case "add":
                this.bankCate = "A3";
                break;
            case "sign":
                this.bankCate = "C5";
                break;
            case "unsign":
                this.bankCate = "C6";
                break;
                // case 'active':
                //   this.bankCate = 'A3'
                //   break
            case "change":
                this.bankCate = "A7";
                break;
            case "modify":
                this.bankCate = "A8";
                break;
            default:
                break;
            }
        },
        imgUp (val) {
            this.imgBase64 = val;
        },
        uploadBankCard () {
            const _this = this;
            _this.$req({
                method: "POST",
                url: "/acct/bankcheck/upload/base64",
                timeout: 60000,
                data: _this.imgBase64,
                headers: { "Content-Type": "multipart/form-data" }})
                .then(res => {
                    if (res.code != "0000000") {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(() => { });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";
    /* 用户持有银行卡信息 */
    .comp-bank-operation {
        margin-bottom: 100px;
        .bank.form-text {
            .bank-msg .bank-img-sel {
                padding: 0;
                margin: 1px 0;
            }
        }
        .other-prompt {
            font-size: $f14;
            margin-left: 20px;
            color: $text-color1;
            vertical-align: middle;
            display: inline-block;
            i {
                color: $color-a;
                margin-right: 5px;
                vertical-align: middle;
            }
        }
        .el-button.info-btn {
            border: none;
            padding: 12px 10px;
            &:hover,
            &:focus {
                background-color: transparent;
            }
        }
    }
</style>
